<template>
  <div :class="classWrapper">
    <div class="label" v-if="mainLabel.length">{{mainLabel}}<small>{{mainSmall}}</small></div>
    <label class="vfl-label" :class="classObject" :for="inputId">
      {{ floatLabel }}
    </label>
    <slot></slot>
    <transition name="slide"><div class="error" v-if="error.length">{{error}}</div></transition>
  </div>
</template>

<script>
export default {
  name: 'float-label',
  props: {
    on: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    mainLabel:{
      type: String,
      default: ''
    },
    mainSmall:{
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    dispatch: {
      type: Boolean,
      default: true
    },
    for: {
      type: String,
      default: null
    },
    error:{
      type: String,
      default: ''
    }
  },
  data () {
    return {
      formEl: undefined,
      labelEl: undefined,
      isActive: false,
      isFocused: false
    }
  },
  mounted () {
    this.formEl = this.$el.querySelector('input, textarea, select, date')
    this.formEl.addEventListener('input', this.updateIsActive)
    this.formEl.addEventListener('input', this.updateIsFocused)
    this.formEl.addEventListener('blur', this.updateIsFocused)
    this.formEl.addEventListener('focus', this.updateIsFocused)

    if (!this.for) {
      this.labelEl = this.$el.querySelector('label')
      this.labelEl.addEventListener('click', this.focusFormEl)
    }

    this.dispatchInput()
  },
  beforeDestroy () {
    this.formEl.removeEventListener('input', this.updateIsActive)
    this.formEl.removeEventListener('input', this.updateIsFocused)
    this.formEl.removeEventListener('blur', this.updateIsFocused)
    this.formEl.removeEventListener('focus', this.updateIsFocused)
  },
  methods: {
    dispatchInput () {
      if (this.dispatch) {
        const event = document.createEvent('HTMLEvents')
        event.initEvent('input', true, false)
        this.formEl.dispatchEvent(event)
      }
    },
    focusFormEl () {
      this.formEl.focus()
    },
    updateIsActive (e) {
      this.isActive = e.target.value.length > 0
    },
    updateIsFocused (e) {
      this.isFocused = e.target === document.activeElement && this.isActive
    }
  },
  watch: {
    dispatch: function(newVal){ // watch it
      if (newVal){
        this.dispatchInput();
      }
    }
  },
  computed: {
    inputId () {
      return this.for
    },
    classObject () {
      return {
        'vfl-label-on-input': this.on && (this.isActive || this.fixed),
        'vfl-label-on-focus': this.isFocused,
        'withLabel': this.mainLabel.length,
        'withSmall': this.mainSmall.length
      }
    },
    classWrapper(){
      return {
        'vfl-has-label': true,
        'vfl-wrapper-on-input': this.on && (this.isActive || this.fixed),
        'vfl-wrapper-on-focus': this.isFocused,
        'has-error': this.error.length,
      }
    },
    formElType () {
      return this.formEl ? this.formEl.tagName.toLowerCase() : '';
    },
    floatLabel () {
      if (this.label) return this.label;
      switch (this.formElType) {
        case 'input':
        case 'textarea':
          return this.formEl.placeholder;
        // case 'select':
          // return this.formEl.placeholder
          // return this.formEl.querySelector('option[disabled][selected]').innerHTML
        default:
          return ''

      }
    }
  }
}
</script>

<style lang="scss">
  /*$main-color: rgba(0,0,0, 1);*/
  $error-color: #f3926b;
  $main-color: rgba(50, 197, 210, 1);
  $main-color-hover: rgba(50, 197, 210, .7);
  /*@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');*/
.vfl-has-label {
  position: relative;
  width: 100%;
}

.vfl-label {
  position: absolute;
  top: 0;
  /*right: 0;*/
  left: 0.1em;
  overflow: hidden;
  font-family: sans-serif;
  font-size: 0.8em;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.2s ease-out;
  color: $main-color;
  margin-bottom: 0;
  &.withLabel{
    top: 35px;
  }
  &.withSmall{
    top: 52px
  }
}

.vfl-label-on-input {
  top: 5px;
  pointer-events: all;
  opacity: 1;
  left: 10px;
  text-align: left;
  &.withLabel{
    top: 40px;
  }
  &.withSmall{
    top: 57px;
  }
}

.vfl-label-on-focus {
  color: $main-color;
}

.vfl-has-label input:focus,
.vfl-has-label textarea:focus,
.vfl-has-label select:focus {
  outline: 0;
}
.error{
  color: $error-color;
  /*color: red;*/
  /*display: none;*/
  /*transition: all 0.2s ease-out;*/
  /*position: relative;*/
  /*opacity: 0;*/
  /*top: -15px;*/
  font-size: 0.9em;
  input,input.form-control{
    border: 1px solid $error-color;
  }
}
.vfl-has-label{
  width: 100%;
  &.vfl-wrapper-on-input{

    >input, >input.form-control{
      padding: 12px 12px 0;
    }
    >select, >select.form-control{
      padding: 15px 12px 0;

    }
    &.has-error {
      > input, > input.form-control {
        border-color: $error-color !important;
      }

      .error {
        display: block;
        /*opacity: 1;*/
        /*top: 0;*/
      }
    }
  }
  &.has-error{
    >input,>input.form-control{
      border-color: $error-color !important;
    }
    .error{
      /*display: block;*/
      /*opacity: 1;*/
      /*top: 0;*/
    }
  }
}
  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }

  .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }

  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }

  //Exclusivo para ONiAd Academy
  /*.form-vue .form-group-vue {*/
  /*  margin-bottom: 15px;*/
  /*}*/
  .form-vue .form-group-vue .form-control {

    width: auto;
    height: 45px;
    padding: 0 12px;
    background-color: #fff;
    border: 1px solid #c2cad8;
    border-radius: 4px;
    box-shadow: none;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

  }
  .form-control {
    outline: none !important;
    box-shadow: none !important;
  }
  .form-control, output {
    font-size: 14px;
    line-height: 1.42857;
    color: #555;
    display: block;
  }
  .form-vue .form-group-vue .label {
    display: inline-block;
    margin-bottom: .5em;
    max-width: 100%;
    font-size: 1em;
    font-weight: 400;
    color: #333;
    line-height: 28px;
    text-align: left;
    padding: 0;
    white-space: normal;
  }
  .form-vue .form-group-vue .label{
    text-align: left;
    > small {
      font-size: 60%;
      display: block;
      text-align: left;
      line-height: 16px;
    }
  }
</style>
